import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9f78fc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "about-position" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = {
  key: 0,
  class: "info-block"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Get Ready To", -1))
const _hoisted_6 = {
  key: 1,
  class: "info-block"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "You'll Be Great At This If You", -1))
const _hoisted_8 = {
  key: 2,
  class: "info-block"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "You'll Be A Hero If You Also", -1))
const _hoisted_10 = {
  key: 3,
  class: "info-block"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Salary", -1))
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.responsabilities)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responsabilities, (resp, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "text",
                    key: `resp-${index}`
                  }, [
                    _createElementVNode("span", null, _toDisplayString(resp), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.requirements)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requirements, (req, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "text",
                    key: `req-${index}`
                  }, _toDisplayString(req), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.additional.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additional, (add, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "text",
                    key: `add-${index}`
                  }, _toDisplayString(add), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.salary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createTextVNode(" Starting at "),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.salary), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}